import { gql, useMutation } from '@apollo/client'
import { path } from 'ramda'
import { useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { qrcodesClient } from '../../utils/apollo/api'
import Editable from '../../packages/kiti/components/form/Editable'

const MUTATION = gql`
  mutation UpsertBucket($input: BucketInput) {
    upsertBucket(input: $input) {
      id
    }
  }
`

const EditableBucket = ({ record, field, children, ...props }) => {
  const { t } = useTranslation('buckets')
  const notify = useNotification()
  const [request, { loading }] = useMutation(MUTATION, { refetchQueries: ['Buckets', 'Bucket'], client: qrcodesClient })

  const handleRequest = value => {
    const params = { variables: { input: { id: record.id, [field]: value } } }
    return request(params).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: t('error.saveError'), message: path(['errors', 0, 'message'], resp) })
      }
    })
  }

  return (
    <Editable value={record[field]} onSubmit={handleRequest} loading={loading} {...props}>
      {children}
    </Editable>
  )
}

export default EditableBucket
